module.exports = __webpack_public_path__ + "img/illinoisAdventure@3x.9f1dbce0.webp";